<template>
    <div class="house-detail">
        <el-dialog
            title="房源详情"
            :visible.sync="showdialog"
            width="1200px"
            :before-close="back">
            <div class="base-warp">
                <div class="left-row">
                    <el-carousel :interval="4000" type="card" height="200px">
                        <el-carousel-item v-for="(item, index) in housedetail.album" :key="index">
                            <el-image class="img" :src="item.path" fit="scale-down"></el-image>
                            <div class="name">{{item.name}}</div>
                        </el-carousel-item>
                    </el-carousel>
                </div>
                <div class="right-edit-box" v-if="id">
                    <el-button type="primary" plain @click="showalbum" size="mini">编辑相册</el-button>
                </div>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form :model="housedetail" label-width="80px" :inline="false" size="mini">
                            <el-form-item label="保证金">
                                <el-input v-model="housedetail.earnest_money" type="number" placeholder="" clearable><i slot="suffix">万</i></el-input>
                            </el-form-item>
                            <el-form-item label="加价幅度">
                                <el-input v-model="housedetail.mark_up" type="number" placeholder="" clearable><i slot="suffix">元</i></el-input>
                            </el-form-item>
                            <el-form-item label="电梯">
                                <el-switch
                                    v-model="housedetail.elevator"
                                    :active-value="true"
                                    active-color="#13ce66">
                                </el-switch>
                            </el-form-item>
                            <el-form-item label="楼层">
                                <el-input v-model="housedetail.floors" placeholder="" clearable></el-input>
                            </el-form-item>
                            <el-form-item label="年代">
                                <el-input type="number" v-model="housedetail.age" placeholder="" clearable></el-input>
                            </el-form-item>
                            <el-form-item label="小区">
                                <el-input v-model="housedetail.plot" placeholder="" clearable></el-input>
                            </el-form-item>
                            <el-form-item label="用途">
                                <el-select v-model="housedetail.property_type" placeholder="请选择" allow-create default-first-option>
                                    <el-option
                                    v-for="item in property_types"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="导师">
                                <div class="flex-box">
                                    <el-input v-model="housedetail.tutorname" placeholder="请点击右侧按钮选择导师" readonly></el-input>
                                    <tutor-list @getTutor="getTutor"></tutor-list>
                                </div>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary" @click="confirm">保存</el-button>
                                <el-button>取消</el-button>
                            </el-form-item>
                        </el-form>
                        
                    </el-col>
                    <el-col :span="12">
                        <el-form :model="housedetail" label-width="80px" :inline="false" size="mini" v-if="housedetail.location">
                            <el-form-item label="房源名称">
                                <p class="text">{{housedetail.name}}</p>
                                <el-button class="right-edit-box" type="primary" plain @click="editbasicsinfo" size="mini">编辑基本信息</el-button>
                            </el-form-item>
                            <el-form-item label="房源地址">
                                <p class="text">{{housedetail.location.address}}</p>
                            </el-form-item>
                            <el-form-item label="面积">
                                <p class="text">{{housedetail.area}}㎡</p>
                            </el-form-item>
                            <el-form-item label="拍卖轮次">
                                <p class="text">{{housedetail.stage}}</p>
                                <el-button class="right-edit-box" type="primary" plain @click="editdynamic" size="mini">编辑动态</el-button>
                            </el-form-item>
                            <el-form-item label="当前价">
                                <p class="text">{{housedetail.current_price}}万</p>
                            </el-form-item>
                            <el-form-item label="拍卖公告">
                                <div class="article-logogram" v-html="article.content"></div>
                                <el-button class="right-edit-box" type="primary" plain @click="editarticle" size="mini">编辑公告</el-button>
                            </el-form-item>
                        </el-form>
                    </el-col>
                </el-row>
            </div>
            <house-album :housedetail="housedetail"></house-album>
            <common-article-edit :article="article" :houseid="id" @input="getarticleinput"></common-article-edit>
        </el-dialog>
        
    </div>
</template>

<script>
import CommonArticleEdit from '../../../components/invest/common-article-edit.vue';
import HouseAlbum from '../../../components/invest/house-album.vue';
import TutorList from '../../../components/tutor-list.vue';
export default {
    components: {
        HouseAlbum,
        CommonArticleEdit,
        TutorList, 
    },
    data() {
        return {
            showdialog: true,
            id: '',
            album: [],
            housedetail: {
                earnest_money: '',
                mark_up: '',
                elevator: false,
                floors: '',
                age: '',
                plot: '',
                property_type: '',
                album: [],
                tutorid: '',
                tutorname: '',
            },
            property_types: [
                {value: '住宅', label: '住宅'},
                {value: '公寓', label: '公寓'},
                {value: '商铺', label: '商铺'},
                {value: '写字楼', label: '写字楼'},
                {value: '厂房', label: '厂房'},
                {value: '社区底商', label: '社区底商'},
                {value: '别墅', label: '别墅'},
            ],
            article: {},
        }
    },
    mounted () {
        this.id = this.$route.query.id;
        this.gethouseinfo();
        this.getforeclosurearticle();
    },
    methods: {
        getTutor(item) {
            this.housedetail.tutorid = item._id['$oid'];
            this.housedetail.tutorname = item.name;
            this.$forceUpdate();
        },
        getarticleinput(value) {
            this.article.content = value;
        },
        editarticle() {
            this.$store.commit('setshowcommonarticleedit', true);
        },
        getforeclosurearticle() {
            var params = {
                id: this.id,
            }
            this.$api.getforeclosurearticle(params)
                .then(data=>{
                    if (data.content) this.article = data;
                })
        },
        gethouseinfo() {
            var params = {
                id: this.id
            }
            this.$api.getforeclosurevsid(params)
                .then(data=>{
                    let {housedetail} = data;
                    if (housedetail.album) housedetail.album = JSON.parse(housedetail.album)
                    this.housedetail = housedetail;
                })
        },
        editdynamic() {
            this.$router.push({path: '/invest/foreclosure/dynamic', query:{id: this.id}});
        },
        editbasicsinfo() {
            this.$router.push({path: '/invest/foreclosure/edit', query:{id: this.id}});
        },
        showalbum() {
            this.$store.commit('setshowhousealbum', true);
        },
        confirm() {
            var params = {
                id: this.id,
                earnest_money: this.housedetail.earnest_money,
                mark_up: this.housedetail.mark_up||'',
                elevator: this.housedetail.elevator||'',
                floors: this.housedetail.floors,
                age: this.housedetail.age,
                plot: this.housedetail.plot,
                property_type: this.housedetail.property_type,
                tutorid: this.housedetail.tutorid||'',
            }
            this.$api.foreclosurehousedetailupdate(params)
                .then(data=>{
                    this.$message.success(data);
                })
        },
        back() {
            this.$router.go(-1);
        }
    },
}
</script>

<style lang="scss" scoped>
.base-warp{
    position: relative;
}
.left-row{
    width: 80%;
}
.right-edit-box{
    position: absolute;
    right: 0;
    top: 0;
}
.article-logogram{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 400px;
    height: 28px;
}
.el-carousel__item {
    background: #fff;
    border: 1px dashed #999;
    .img{
        width: 100%;
        height: 202px;
        vertical-align: middle;
        position: relative;
    }
    .name{
        position: absolute;
        color: #fff;
        padding: 0 6px;
        background: rgba(0, 0, 0, 0.4);
        bottom: 4px;
        left: 4px;
    }
}
.el-carousel__item:nth-child(2n) {
    background-color: #fff;
    border: 1px dashed #eee;
}

.el-carousel__item:nth-child(2n+1) {
    background-color: #fff;
    border: 1px dashed #eee;
}
</style>